import React from "react";
import "./signInFormHeaderMainTxt.scss";

const SignInFormHeaderMainTxt = ({ txt }) => (
  <span className="sign-in-form-header-main-txt">{txt}</span>
);

export default SignInFormHeaderMainTxt;
